import styled from 'styled-components';

const ContentWrapper = styled.div`
  margin-left: 7rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
  margin-right: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export default ContentWrapper;
